/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import '@fancyapps/fancybox';
import 'flickity';

$(document).ready(() => {

  /**
   * Debug
   */
  document.addEventListener('keydown', function (e) {
    if (e.code == 'F19') {
      document.querySelector('#ui-debug__checkbox').click();
    }
  });

  document.querySelector('#ui-debug__checkbox').addEventListener('change', function () {
    document.documentElement.classList.toggle('ui-debug-active');
  });

  /**
   * Fancybox
   */
  var isImage = function (href) {
    return href.indexOf('.jpg') !== -1 || href.indexOf('.jpeg') !== -1 || href.indexOf('.png') !== -1;
  }

  // image block
  $('.wp-block-image').each(function () {
    var $this = $(this);
    var $item = $this.find('a');
    if ($item.length && isImage($item.attr('href'))) {
      $item.attr('data-fancybox', '');
    }
  });

  // gallery block
  $('.wp-block-gallery').each(function(){
    var $this = $(this);
    var galleryId = 'gallery-' + Math.random().toString(36).substring(7);
    var items = $this.find('a');
    items.each(function(idx, item){
      var $item = $(item);
      if (isImage($item.attr('href'))) {
        $item.attr('data-fancybox', galleryId);
      }
    })
  });

  // WooCommerce single product
  $('.woocommerce-product-gallery__wrapper').each(function(){
    var $this = $(this);
    var galleryId = 'gallery-' + Math.random().toString(36).substring(7);
    var items = $this.find('a');
    items.each(function(idx, item){
      var $item = $(item);
      if (isImage($item.attr('href'))) {
        $item.attr('data-fancybox', galleryId);
      }
    })
  });

  // Setup
  $('[data-fancybox]').fancybox({
    loop: true,
    buttons: [
      'close',
    ],
    btnTpl: {
      arrowLeft:
        '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
        '<div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M26.95 48.21l31.632-31.26a3.217 3.217 0 014.565 0l1.907 1.913a3.245 3.245 0 010 4.581L37.584 50.5l27.443 27.056a3.245 3.245 0 010 4.58L63.12 84.05a3.217 3.217 0 01-4.565 0L26.923 52.79a3.27 3.27 0 01.027-4.58z"/></svg></div>' +
        '</button>',

      arrowRight:
        '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
        '<div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M65.05 52.79L33.418 84.05a3.217 3.217 0 01-4.565 0l-1.907-1.913a3.245 3.245 0 010-4.581L54.416 50.5 26.973 23.444a3.245 3.245 0 010-4.58l1.907-1.914a3.217 3.217 0 014.565 0l31.632 31.26a3.27 3.27 0 01-.027 4.58z"/></svg></div>' +
        '</button>',

      close:
        '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
        '<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M57.395 50.499l20.833 20.833 4.297 4.296a1.626 1.626 0 010 2.298l-4.597 4.597a1.626 1.626 0 01-2.298 0l-25.129-25.13-25.13 25.132a1.626 1.626 0 01-2.297 0l-4.599-4.597a1.626 1.626 0 010-2.298L43.607 50.5l-25.132-25.13a1.626 1.626 0 010-2.297l4.597-4.597a1.626 1.626 0 012.298 0L50.5 43.605l20.833-20.833 4.296-4.297a1.626 1.626 0 012.298 0l4.597 4.597a1.626 1.626 0 010 2.298l-25.13 25.129z"/></svg>' +
        '</button>',
    },
  });

  /**
   * CSS --scroll
   */
  window.addEventListener(
    "scroll",
    () => {
      document.body.style.setProperty(
        "--scroll",
        window.pageYOffset / (document.body.offsetHeight - window.innerHeight)
      );
    },
    false
  );

});
